import React, { useState } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { ArrayField, Button, Datagrid, FunctionField, NumberField, ReferenceField, SelectField } from "react-admin";
import { settings } from "app";
import { getProfessorRecordText } from "server/components/Fields/_fieldsHelper";
import { ExamCommissionRoles } from "utils/choices";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import EditIcon from "@mui/icons-material/Edit";
import SessionExamProfessorEditForm from "./SessionExamProfessorEditForm";
import { employeeRequests } from "api/employeeApi";

const SessionExamProfessor = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  const [isProfessorEditing, setIsProfessorEditing] = useState(false);

  const handleProfessorEditClick = () => {
    setIsProfessorEditing(true);
  };

  return (
    <Grid
      container
      spacing={2}
      gap={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      {isProfessorEditing ? (
        <SessionExamProfessorEditForm
          setIsProfessorEditing={setIsProfessorEditing}
          record={record}
        />
      ) : (
        <>
          <Grid
            item
            xs={12}
          >
            <ArrayField
              source="professors"
              label=""
            >
              <Datagrid
                rowClick={false}
                bulkActionButtons={false}
                sx={settings.style.detailsDatagrid}
              >
                <ReferenceField
                  source="professorEmployeeId"
                  reference={employeeRequests.getProfessorsSelect()}
                  linkType={false}
                  label="Преподавател"
                >
                  <FunctionField render={getProfessorRecordText} />
                </ReferenceField>

                <SelectField
                  source="role"
                  label="Роля"
                  choices={ExamCommissionRoles}
                  emptyText="-"
                />
                <NumberField
                  source="commissionNumber"
                  label="Комисия #"
                />
              </Datagrid>
            </ArrayField>
          </Grid>
          <SecuredComponent permission={permissions.canUpdateSessionExamProfessors}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<EditIcon />}
              label="Редактирай"
              onClick={handleProfessorEditClick}
              sx={{ ml: 2 }}
            />
          </SecuredComponent>
        </>
      )}
    </Grid>
  );
};

export default SessionExamProfessor;
